import ScrollTo from 'common/scroll_to';

import React, { Component } from 'react';
import classNames from 'classnames';
import times from 'lodash/times';

import propTypes from 'prop-types';

const MAX_VALUE = 5;

export const Stars = ({ num, className }) => {
  className = classNames('star-rating__star', className);
  return times(num).map(i => <div className={className} key={i} />);
};

export default class StarRating extends Component {
  static propTypes = {
    count: propTypes.number,
    value: propTypes.number,
    scrollElementId: propTypes.string,
  };

  render() {
    const { value, count } = this.props;
    const fullStars = Math.floor(value);
    const halfStars = Math.ceil(value - fullStars);
    const emptyStars = MAX_VALUE - (fullStars + halfStars);
    return (
      <div
        className={classNames('star-rating', {
          'star-rating--clickable': !!this.props.scrollElementId,
          'star-rating--no-reviews': count === 0,
        })}
      >
        <div
          className="star-rating__stars"
          onClick={() => this.scrollToReviews()}
        >
          <Stars num={fullStars} className="star-rating__star" />
          <Stars
            num={halfStars}
            className="star-rating__star star-rating__star--half"
          />
          <Stars
            num={emptyStars}
            className="star-rating__star star-rating__star--empty"
          />
        </div>
        {this.renderRatingCount(count)}
      </div>
    );
  }

  renderRatingCount(count) {
    return (
      count > 0 && (
        <div
          className="star-rating__count text greyish-brown"
          onClick={() => this.scrollToReviews()}
        >
          ({count})
        </div>
      )
    );
  }

  scrollToReviews() {
    if (!this.props.scrollElementId) {
      return;
    }

    ScrollTo.scrollVerticalToElementById(this.props.scrollElementId, 20);
  }
}
